<script setup lang="ts">
useHead({
  title: "Wystapił bląd",
});

defineProps<{
  error: {
    statusMessage: string;
  };
}>();

const handleError = () => clearError({ redirect: "/" });
</script>

<template>
  <NuxtLayout name="clear-logo">
    <PrimeCard>
      <template #content>
        <PageNotFound v-if="error.statusMessage?.includes('Page not found')">
          <PrimeButton rounded @click="handleError">
            Przejdź do strony głównej
          </PrimeButton>
        </PageNotFound>

        <section v-else class="flex items-center justify-center font-inter">
          <div class="max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
            <div class="mx-auto max-w-screen-sm space-y-6 text-center">
              <h1
                v-if="error.statusMessage"
                class="text-bluegray-900 mb-4 text-3xl font-bold tracking-tight md:text-4xl"
              >
                {{ error.statusMessage }}
              </h1>

              <p class="text-global-textColor mb-4 text-lg font-light">
                Przepraszamy za niedogodności.
              </p>

              <PrimeButton rounded @click="handleError">
                Przejdź do strony głównej
              </PrimeButton>
            </div>
          </div>
        </section>
      </template>
    </PrimeCard>
    <DefaultToast position="bottom-right" />
  </NuxtLayout>
</template>
